import {
  subscribeToContentCardsUpdates,
  logCustomEvent,
  requestContentCardsRefresh
} from "@braze/web-sdk";
import {store} from "../../../redux/store";
import { isBrazeReady } from "../../utilities/brazeReady";
import {contentCardsUpdated} from "../../../redux/actions/braze";
import {getMockContentCards} from "../../constants/mockContentCards";
import {canTrackAnalytics} from "../../utilities/cookieConsent";

export const subscribeToContentCardUpdates = () => {
    try {
        // Check if mock content cards mode is enabled before subscribing
        const state = store.getState();
        const siteSettings = state.siteSettings || {};
        
        // Check site setting OR fall back to environment variable for local development
        // Note: Only enable if explicitly set to "true" (string) to avoid accidental enablement
        const isMockEnabled = siteSettings.mockBrazeContentCards === true 
            || (typeof window !== 'undefined' && window.environment?.REACT_APP_MOCK_BRAZE_CONTENT_CARDS === "true")
            || process.env.REACT_APP_MOCK_BRAZE_CONTENT_CARDS === "true";

        // If mock mode is enabled, dispatch mock data immediately (don't wait for Braze API)
        if (isMockEnabled) {
            const mockCards = getMockContentCards();
            store.dispatch(contentCardsUpdated(mockCards));
        }

        if (!isBrazeReady()) {
            return;
        }

        // Subscribe to Braze updates (still needed for analytics/reporting)
        subscribeToContentCardsUpdates(cardData => {
            // Only dispatch real data if mock mode is NOT enabled
            if (!isMockEnabled) {
                store.dispatch(contentCardsUpdated(cardData));
            }
            // If mock mode IS enabled, we already dispatched mock data above, so ignore real data
        });

        requestContentCardsRefresh();

        /* eslint-disable no-empty */
    } catch (exception) {

    }
}

export const logEvent = (eventName, eventProperties) => {
    if (!isBrazeReady()) {
        return;
    }
    try {
        logCustomEvent(
            eventName,
            eventProperties
        );
        /* eslint-disable no-empty */
    } catch (exception) {

    }
}

/**
 * Track when a hero carousel card is viewed
 */
export const logHeroCardViewed = (card, position, campaign, region) => {
  if (!canTrackAnalytics()) return;

  logEvent("hero_card_viewed", {
    card_id: card?.id,
    position,
    campaign,
    region
  });
};

/**
 * Track CTA clicks in hero carousel
 */
export const logHeroCtaClicked = (cardId, ctaText, destination) => {
  if (!canTrackAnalytics()) return;

  logEvent("hero_cta_clicked", {
    card_id: cardId,
    cta_text: ctaText,
    destination
  });
};

/**
 * Track swipe/scroll interactions in hero carousel
 */
export const logHeroSwipe = (direction, cardFrom, cardTo) => {
  if (!canTrackAnalytics()) return;

  logEvent("hero_swipe", {
    direction,
    card_from: cardFrom,
    card_to: cardTo
  });
};
